export default __webpack_public_path__ + "static/media/pixels-project-4.dd80d41e.webp";